import { createPostAPI } from '@cuemath/rest-api';
import { BASE_URL } from 'constants/api';

const { usePost: useTokboxSessionTokenPost } = createPostAPI({
  getURL: () => `${BASE_URL}/av/session-token/`,
});

const { usePost: useHMSTokenPost } = createPostAPI({
  getURL: () => `${BASE_URL}/av/hms-room/`,
});

export { useTokboxSessionTokenPost, useHMSTokenPost };
